import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const IdCardUsagePolicy: React.FC = () => (
  <PolicyPage slug="id-card-usage-policy" subtitle="ID Card Usage Policy" />
);

export default IdCardUsagePolicy;
